import * as server from '../entries/pages/thank-you/_page.server.js';

export const index = 7;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/thank-you/_page.svelte.js')).default;
export { server };
export const server_id = "src/routes/thank-you/+page.server.js";
export const imports = ["_app/immutable/nodes/7.y-inr0Hg.js","_app/immutable/chunks/cL9VaPgy.js","_app/immutable/chunks/C75YQU_W.js","_app/immutable/chunks/Dj1UN0wv.js","_app/immutable/chunks/DO7XS9iS.js"];
export const stylesheets = [];
export const fonts = [];
